import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRemoveFiltersFlat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M7.317 8.756 4.398 5.838a1.018 1.018 0 0 1 .72-1.738H7.38a3 3 0 0 1 .81-1.5H5.119a2.518 2.518 0 0 0-1.78 4.298L6.4 9.961c.234.235.366.553.366.884v5.145a1.25 1.25 0 0 0 1.645 1.186l4-1.334c.51-.17.855-.648.855-1.186v-1.94h-1.5v1.76l-3.5 1.167v-3.736a3 3 0 0 1-.95-2.19v-.96Z"
      clipRule="evenodd"
    />
    <path d="M8.617 3.017a.99.99 0 0 1 1.4 0l7 7a.99.99 0 1 1-1.4 1.4l-7-7a.99.99 0 0 1 0-1.4" />
    <path d="M17.017 3.017a.99.99 0 0 0-1.4 0l-7 7a.99.99 0 0 0 1.4 1.4l7-7a.99.99 0 0 0 0-1.4" />
  </svg>
);
export default SvgRemoveFiltersFlat;
